export default function fab({ variables }) {
    return {
        MuiFab: {
            defaultProps: {
                size: "medium",
            },
            styleOverrides: {
                root: {
                    textTransform: "none",
                    fontSize: variables.type_body_sm_font_size,
                    fontWeight: variables.font_weight_medium,
                    boxShadow: variables.box_shadow_small,
                },
                primary: {
                    backgroundColor: variables.interactive,
                    color: variables.text_inverse,
                    "&:hover": {
                        backgroundColor: variables.interactive_hover,
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=fab.js.map